<template>
  <div>
    <div class="cert-header d-flex py-5">
      <div class="col-12 col-md-11 col-lg-10 col-xl-9 px-3 p-md-0 mx-auto">
        <div ref="title" class="cert-title cert-large">About Us</div>
      </div>
    </div>
    <div ref="content" class="col-12 col-md-11 col-lg-10 col-xl-9 p-3 p-sm-5 mx-auto mt-2 mt-sm-5 cert-page-content">
      <div class="cert-section-light">
        <div class="cert-section-text mb-4">
          Rw-CERT is the Rwanda Computer Emergency Response Team that coordinates efforts for early detection,
          prevention and response against cyber-related incidents. It supports members of public, and private
          institutions and the entire cyber community affected by cyber incidents by educating and providing information
          and recommendations through timely
          <router-link :to="{path: '/alerts'}" style="font-weight: 600">alerts</router-link>
          and
          <router-link :to="{path: '/advisories'}" style="font-weight: 600">advisories</router-link>
          . For more details, refer to the <a
            style="font-weight: 600"
            href="//cyber.gov.rw/index.php?eID=dumpFile&t=f&f=346&token=46f9506ee0b1ff8c9cd629cc5c40b17bf6785105"
            target="_blank">RFC2350
          <micon style="font-size: 1rem" icon="launch"/>
        </a>.
          <br/>
          <br/>
          Rw-CERT operates under the National Cyber Security Authority (NCSA) effective from 15 December 2020 and was
          established in August 2014 as Rwanda Computer Security Incident Response Team (Rw-CSIRT) with the same
          mandate.
          <br/>
          <br/>
          Some examples of cyber-related incidents that the team handles are:
        </div>
        <div class="cert-incident-parent mb-4 col-12 col-xl-10 mx-auto d-flex flex-row flex-wrap">
          <div ref="i1" class="col-12 col-md-6 col-lg-4 col-xl-4 mx-auto">
            <cert-incident-container title="Phishing" img="phishing.png" path="/phishing"/>
          </div>
          <div ref="i2" class="col-12 col-md-6 col-lg-4 col-xl-4 mx-auto">
            <cert-incident-container title="DDOS" img="ddos.png" path="/ddos"/>
          </div>
          <div ref="i3" class="col-12 col-md-6 col-lg-4 col-xl-4 mx-auto">
            <cert-incident-container title="Web Defacement" img="deface.png" path="/defacement"/>
          </div>
          <div ref="i4" class="col-12 col-md-6 col-lg-4 col-xl-4 mx-auto">
            <cert-incident-container title="Security Breach" img="breach.png" path="/breach"/>
          </div>
          <div ref="i5" class="col-12 col-md-6 col-lg-4 col-xl-4 mx-auto">
            <cert-incident-container title="Malware" img="malware.png" path="/malware"/>
          </div>
          <div ref="i6" class="col-12 col-md-6 col-lg-4 col-xl-4 mx-auto">
            <cert-incident-container title="Password Theft" img="password.png" path="/password"/>
          </div>
        </div>

      </div>
    </div>
    <!--    Partners-->
    <div class=" d-flex">
      <div class="col-12 col-md-9 col-xl-6 mx-auto row py-5">
        <div class="col-12 col-sm-6 d-flex">
          <a href="//cyber.gov.rw" target="_blank" class="mx-auto my-2">
            <img class="cert-img-alt mx-auto" src="../../assets/img/ncsa-logo.png"/>
          </a>
        </div>
        <div class="col-12 col-sm-6 d-flex">
          <a href="//getsafeonline.org.rw/" target="_blank" class="mx-auto my-2">
            <img class="cert-img-alt mx-auto" src="../../assets/img/gso-logo.png"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CertIncidentContainer from './components/CertIncidentContainer.vue';

export default {
  name: "About",
  components: {
    CertIncidentContainer
  },
  methods: {},
  mounted() {
    this.$anim.fadeInBottomOpaque(this.$refs["content"], 50);
    for (let i = 1; i < 7; i++)
      this.$anim.fadeInBottom(this.$refs[`i${i}`], 50 * (i + 1));
  }
}
</script>